<!--  -->
<template>
  <div style="background:#fff;padding:20px">
    <header class="header">
      <span>新建/编辑教师</span>
      <el-button @click="$router.go(-1)" class="fr">返回</el-button>
      <!-- <router-link to="/alliance/teacher/batch-import">
        <el-button type="primary">导入excle</el-button>
      </router-link>-->
    </header>
    <div>
      <el-form ref="formValidate" :model="teacher" label-width="100px" :rules="ruleValidate">
        <el-row>
          <el-col :span="6">
            <el-form-item label="用户ID" prop="userId">
              <el-input v-model="teacher.userId" disabled></el-input>
            </el-form-item>
            <el-form-item label="真实姓名" prop="teacherName">
              <el-input v-model="teacher.teacherName"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="mobile">
              <el-input v-model="teacher.mobile"></el-input>
            </el-form-item>
            <el-form-item label="邮箱号" prop="email">
              <el-input v-model="teacher.email"></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="sex">
              <el-radio-group v-model="teacher.sex">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="2">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="高校" prop="schoolId">
              <el-select
                disabled
                v-model="teacher.schoolId"
                @input="getSchoolChange(teacher.schoolId,'reset')"
              >
                <el-option
                  v-for="item in schoolData"
                  :key="item.schoolId"
                  :value="item.schoolId"
                  :label="item.schoolName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="学院" prop="collegeId">
              <el-select v-model="teacher.collegeId">
                <el-option
                  v-for="item in collegeData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="teacher.remark" type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary" @click="handleSubmit('formValidate')">确认绑定</el-button>
          <el-button @click="userVisible=true">选择已有账号</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
      title="选择已有账号"
      :visible.sync="userVisible"
      :close-on-press-escape="false"
      top="2vh"
      :close-on-click-modal="false"
      width="800px"
    >
      <user @getConsultant="getSelect"></user>
    </el-dialog>
  </div>
</template>

<script>
import user from "@/components/dialog/userRadio.vue";
export default {
  data() {
    return {
      schoolData: [], // 高校
      collegeData: [], // 学院
      userVisible: false,
      modal: false,
      teacher: {
        collegeId: null, // 学院id
        email: "", // 邮箱
        mobile: "", // 手机号
        remark: "", // 备注
        schoolId: null, // 高校id
        sex: 1, // 性别
        teacherId: 0, // 数据库自增id
        teacherName: "", // 真实姓名
        userId: 0 // 点宽用户id，用于绑定, 如果为空说明需要创建
      },
      ruleValidate: {
        // email: [{ required: true,validator: this.sendEmail,trigger: "blur" }],
        email: [
          { required: true, message: "邮箱不能为空", trigger: "blur" },
          {
            pattern: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/,
            message: "邮箱格式不正确",
            trigger: "blur"
          }
        ],
        mobile: [
           { required: true, message: "手机号不能为空", trigger: "blur" },
          {
            required: true,
            pattern: /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/,
            message: "手机号格式不正确",
            trigger: "blur"
          }
        ],
        schoolId: [{ required: true, message: "请选择高校", trigger: "blur" }],
        collegeId: [
          { required: true, message: "请选择学院", trigger: "change" }
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
        teacherName: [
          { required: true, message: "真实姓名不能为空", trigger: "blur" }
        ],
        remark: []
      },
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "用户名",
          key: ""
        },
        {
          title: "昵称",
          key: "nickname"
        },
        {
          title: "手机",
          key: "mobile"
        },
        {
          title: "邮箱",
          key: "email"
        }
      ],
      userList: []
    };
  },
  components: { user },
  methods: {
    // 手机正则
    validatorPhone(rule, value, callback) {
      if (value === "") {
        callback(new Error("手机号不能为空"));
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error("手机号格式错误"));
      }
    },
    // 邮箱正则
    sendEmail(rule, value, callback) {
      if (value === "") {
        callback(new Error("邮箱不能为空"));
      } else if (
        !/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(
          value
        )
      ) {
        callback(new Error("邮箱格式不正确"));
      }
    },
    // 高校
    getSchoolChange(item, type) {
      // 获取学院列表
      const param = {
        showItem: 1000,
        schoolId: item,
        pageIndex: 1,
        word: ""
      };
      // 学院select
      this.$api.allianceSchool.getCollegeList(param).then(res => {
        if (res.errCode == 0) {
          this.collegeData = res.data.items;
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    // 用户弹窗
    getSelect(res) {
      this.teacher.teacherName = res.realName || res.userName;
      this.teacher.mobile = res.phoneNumber;
      this.teacher.email = res.email;
      this.teacher.userId = res.userId;
      this.userVisible = false;
    },
    //  初始化数据
    ngOnInit() {
      const paramSchool = {
        word: ""
      };
      // 高校select
      this.$api.allianceSchool.getSchoolList(paramSchool).then(res => {
        if (res.errCode == 0) {
          this.schoolData = res.data;
          this.teacher.schoolId = Number(this.$route.query.schoolId);
        } else {
          this.$message.error(res.errMsg);
        }
      });
      // 获取教师信息query
      if (this.$route.query.teacherId) {
        const paramTeacher = {
          schoolId: this.$route.query.schoolId,
          teacherId: this.$route.query.teacherId
        };
        this.$api.allianceSchool.getTeacherInfo(paramTeacher).then(res => {
          if (res.errCode == 0) {
            this.teacher = res.data;
          } else {
            this.$message.error(res.errMsg);
          }
        });
      }
    },
    handleSubmit(name) {
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          this.$api.allianceSchool.updateTeacher(this.teacher).then(res => {
            if (res.errCode == 0) {
              this.$message.success("提交成功!");
              this.$router.go(-1);
            } else {
              this.$message.error(res.errMsg);
            }
          });
        }
      });
    }
  },
  created() {
    this.ngOnInit();
    this.getSchoolChange(this.$route.query.schoolId);
  }
};
</script>
<style lang='less' scoped>
</style>